import config from "../config";

const log = (...args) => {
    if (config.environment === 'DEVELOPMENT') {
      console.log(...args);
    }
  };
  
export default log;